var UserService = /** @class */ (function () {
    function UserService(api) {
        this.API = api;
    }
    UserService.prototype.getAppAdmins = function (appId) {
        var url = "/users/level/appadmin:".concat(appId);
        return this.API.get(url);
    };
    UserService.prototype.requestProfileInfo = function () {
        var url = "/users/me/data";
        return this.API.getFile(url);
    };
    UserService.prototype.listUsers = function (organizationId) {
        var url;
        if (organizationId)
            url = "/users/level/org:".concat(organizationId);
        else
            url = "/users/";
        return this.API.get(url);
    };
    UserService.prototype.getUser = function (userId, appId) {
        if (appId === void 0) { appId = null; }
        var options;
        if (appId) {
            options = { appId: appId };
        }
        var url = "/users/".concat(userId);
        return this.API.get(url, options);
    };
    UserService.prototype.getAppUsers = function (appId) {
        var url = "/groups/app:".concat(appId, ":users/members");
        return this.API.get(url);
    };
    UserService.prototype.createUser = function (_a) {
        var appId = _a.appId, user = _a.user, sendInviteEmail = _a.sendInviteEmail, externalUser = _a.externalUser, userAppId = _a.userAppId, groups = _a.groups, organizationId = _a.organizationId;
        var url = '/users';
        var data = {
            user: user,
            send_invite_email: sendInviteEmail,
            external_user: externalUser,
            userAppId: userAppId,
            groups: groups,
            organization_id: organizationId,
        };
        return this.API.post(url, data, { appId: appId });
    };
    UserService.prototype.deleteUser = function (userId, appId) {
        if (appId === void 0) { appId = null; }
        var options;
        if (appId) {
            options = { appId: appId };
        }
        var url = "/users/".concat(userId);
        return this.API.delete(url, {}, options);
    };
    UserService.prototype.updateUserName = function (userId, name, last_name, userGroups, appId) {
        if (appId === void 0) { appId = null; }
        var options;
        if (appId) {
            options = { appId: appId };
        }
        var url = "/users/".concat(userId);
        return this.API.patch(url, { name: name, meta: { last_name: last_name }, groups: userGroups }, false, options);
    };
    UserService.prototype.importExcel = function (formData, appId) {
        var url = '/users/import';
        return this.API.postFormData(url, formData, {
            appId: appId,
        });
    };
    UserService.prototype.importExcelTemplate = function () {
        var url = '/users/import/template';
        return this.API.getFile(url);
    };
    UserService.prototype.inviteAgain = function (userIds, appId, org) {
        var url = '/users/invite/again';
        var data = {
            user_ids: userIds,
            organization_id: org,
        };
        return this.API.post(url, data, { appId: appId });
    };
    UserService.prototype.exportToExcel = function () {
        var url = '/users/export';
        return this.API.getFile(url);
    };
    UserService.prototype.getLastAdminOrgs = function (userId) {
        var url = "/users/".concat(userId, "/last_admin_orgs");
        return this.API.get(url);
    };
    UserService.prototype.performBulkDelete = function (appId, userIdArray) {
        var url = "/users/app-users/bulk-delete";
        var data = {
            user_ids: userIdArray,
        };
        return this.API.delete(url, data, { appId: appId });
    };
    return UserService;
}());
export { UserService };
